import React, { ReactNode, useMemo } from "react";
import { changeEgovUrl } from "@/utils/tools";

enum nameType {
  others = 0,
  enOneWord = 1,
  enTwoWords = 2,
  zh = 3
}

const zhPattern = /[\u4E00-\u9FA5]+/;
const enOneWordPattern = /[A-Za-z0-9]+/;
const enTwoWordsPattern = /[A-Za-z0-9]+[$][A-Za-z0-9]+/;
const defaultSize = 40;

function applyRule(name: string) {
  return defaultRule(name);
}

function defaultRule(name: string) {
  const filteredName = filterName(name);
  let language;
  let str;
  if (zhPattern.test(filteredName)) {
    language = nameType.zh;
  } else if (enOneWordPattern.test(filteredName)) {
    language = nameType.enOneWord;
  } else if (enTwoWordsPattern.test(filteredName)) {
    language = nameType.enTwoWords;
  } else {
    language = nameType.others;
  }
  let strArr;
  switch (language) {
    case nameType.zh:
      str = filteredName[0];
      break;
    case nameType.enTwoWords:
      strArr = filteredName.split(" ");
      str = strArr[0][0] + strArr[1][0];
      break;
    case nameType.enOneWord:
    case nameType.others:
      str = filteredName.substring(0, 2);
      break;
    default:
      break;
  }
  return str;
}

function filterName(name: string) {
  return name
    .trim()
    .split("")
    .filter((char: string) => {
      return zhPattern.test(char) || enOneWordPattern.test(char) || /\s/.test(char);
    })
    .join("");
}

export function Avatar(props: {
  size?: number;
  styleObj?: any;
  className?: string;
  src?: string;
  name?: string;
  defaultImg?: string;
  onClick?: (e?: any) => void;
  fullName?: boolean;
  IconFont?: ReactNode;
}): any {
  const { styleObj, src, name, className, onClick, size, fullName, IconFont } = props;
  const divAvatarNode = useMemo(() => {
    if (IconFont) {
      return (
        <div
          className={`me-avatar avatar-mask ${className || ""}`}
          style={{
            width: size || defaultSize,
            height: size || defaultSize,
            borderRadius: 6,
            fontSize: 16,
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            outline: 0,
            ...styleObj
          }}
          onClick={onClick}
        >
          {IconFont}
        </div>
      );
    }
    if (name) {
      const displayName = fullName ? name : name[0];
      // const displayName = fullName ? name : applyRule(name);
      return (
        <div
          className={`me-avatar avatar-mask ${className || ""}`}
          style={{
            width: size || defaultSize,
            height: size || defaultSize,
            borderRadius: 6,
            fontSize: 16,
            display: "flex",
            textAlign: "center",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            outline: 0,
            ...styleObj
          }}
          onClick={onClick}
        >
          {displayName}
        </div>
      );
    }

    return null;
  }, [name, IconFont, fullName, className, size, styleObj, onClick]);

  const imgAvatarNode = useMemo(() => {
    let src1 =
      src && (src.includes("downloadAuthn") ? src.replace("downloadAuthn", "download") : src);
    return (
      <img
        className={`${className} user-card-avatar-remote`}
        style={{
          width: size || defaultSize,
          height: size || defaultSize,
          borderRadius: 6,
          backgroundSize: "cover",
          backgroundColor: "#ddd",
          overflow: "hidden",
          display: "block",
          backgroundPositionY: "center",
          outline: 0,
          // backgroundImage: `url(${changeEgovUrl(src1)})`,
          ...styleObj
        }}
        onClick={onClick}
        src={changeEgovUrl(src1)}
      />
    );
  }, [className, size, styleObj, src, onClick]);
  let filteredSrc = "";
  if (src) {
    filteredSrc = filterUselessImg(src);
  }
  if (!filteredSrc) {
    return divAvatarNode;
  } else {
    return imgAvatarNode;
  }
}

export function filterUselessImg(imgUrl: string) {
  if (imgUrl.includes("ebook.avatar.getDefaultAvatar")) {
    return "";
  }

  return imgUrl;
}
